import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getUserListingData: {
    loading: false,
    error: null,
    data: null,
  },
  createUser: {
    loading: false,
    error: null,
    data: null,
  },
  assignDevice: {
    loading: false,
    error: null,
    data: null,
  },
  removeDevice: {
    loading: false,
    error: null,
    data: null,
  },
  storeTimezone: {
    loading: false,
    error: null,
    data: null,
  },
  getTimezones: {
    loading: false,
    error: null,
    data: null,
  },
  authenticatorSetup: {
    loading: false,
    error: null,
    data: null,
  },
};

const authSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    getUserListingDataStart: (state) => {
      state.getUserListingData.loading = true;
      state.getUserListingData.error = null;
      state.getUserListingData.data = null;
    },
    getUserListingDataSuccess: (state, action) => {
      state.getUserListingData.loading = false;
      state.getUserListingData.data = action.payload;
      state.getUserListingData.error = null;
    },
    getUserListingDataFailure: (state, action) => {
      state.getUserListingData.loading = false;
      state.getUserListingData.error = action.payload;
      state.getUserListingData.data = null;
    },
    getUserListingDataResetForm: (state, action) => {
      state.getUserListingData.loading = false;
      state.getUserListingData.error = null;
      state.getUserListingData.data = null;
    },
    createUserStart: (state) => {
      state.createUser.loading = true;
      state.createUser.error = null;
      state.createUser.data = null;
    },
    createUserSuccess: (state, action) => {
      state.createUser.loading = false;
      state.createUser.data = action.payload;
      state.createUser.error = null;
    },
    createUserFailure: (state, action) => {
      state.createUser.loading = false;
      state.createUser.error = action.payload;
      state.createUser.data = null;
    },
    createUserResetForm: (state, action) => {
      state.createUser.loading = false;
      state.createUser.error = null;
      state.createUser.data = null;
    },
    assignDeviceStart: (state) => {
      state.assignDevice.loading = true;
      state.assignDevice.error = null;
      state.assignDevice.data = null;
    },
    assignDeviceSuccess: (state, action) => {
      state.assignDevice.loading = false;
      state.assignDevice.data = action.payload;
      state.assignDevice.error = null;
    },
    assignDeviceFailure: (state, action) => {
      state.assignDevice.loading = false;
      state.assignDevice.error = action.payload;
      state.assignDevice.data = null;
    },
    assignDeviceResetForm: (state, action) => {
      state.assignDevice.loading = false;
      state.assignDevice.error = null;
      state.assignDevice.data = null;
    },
    removeDeviceStart: (state) => {
      state.removeDevice.loading = true;
      state.removeDevice.error = null;
      state.removeDevice.data = null;
    },
    removeDeviceSuccess: (state, action) => {
      state.removeDevice.loading = false;
      state.removeDevice.data = action.payload;
      state.removeDevice.error = null;
    },
    removeDeviceFailure: (state, action) => {
      state.removeDevice.loading = false;
      state.removeDevice.error = action.payload;
      state.removeDevice.data = null;
    },
    removeDeviceResetForm: (state, action) => {
      state.removeDevice.loading = false;
      state.removeDevice.error = null;
      state.removeDevice.data = null;
    },

    storeTimezoneStart: (state) => {
      state.storeTimezone.loading = true;
      state.storeTimezone.error = null;
      state.storeTimezone.data = null;
    },
    storeTimezoneSuccess: (state, action) => {
      state.storeTimezone.loading = false;
      state.storeTimezone.data = action.payload;
      state.storeTimezone.error = null;
    },
    storeTimezoneFailure: (state, action) => {
      state.storeTimezone.loading = false;
      state.storeTimezone.error = action.payload;
      state.storeTimezone.data = null;
    },
    storeTimezoneResetForm: (state, action) => {
      state.storeTimezone.loading = false;
      state.storeTimezone.error = null;
      state.storeTimezone.data = null;
    },

    getTimezonesStart: (state) => {
      state.getTimezones.loading = true;
      state.getTimezones.error = null;
      state.getTimezones.data = null;
    },
    getTimezonesSuccess: (state, action) => {
      state.getTimezones.loading = false;
      state.getTimezones.data = action.payload;
      state.getTimezones.error = null;
    },
    getTimezonesFailure: (state, action) => {
      state.getTimezones.loading = false;
      state.getTimezones.error = action.payload;
      state.getTimezones.data = null;
    },
    getTimezonesResetForm: (state, action) => {
      state.getTimezones.loading = false;
      state.getTimezones.error = null;
      state.getTimezones.data = null;
    },

    authenticatorSetupStart: (state) => {
      state.authenticatorSetup.loading = true;
      state.authenticatorSetup.error = null;
      state.authenticatorSetup.data = null;
    },
    authenticatorSetupSuccess: (state, action) => {
      state.authenticatorSetup.loading = false;
      state.authenticatorSetup.data = action.payload;
      state.authenticatorSetup.error = null;
    },
    authenticatorSetupFailure: (state, action) => {
      state.authenticatorSetup.loading = false;
      state.authenticatorSetup.error = action.payload;
      state.authenticatorSetup.data = null;
    },
    authenticatorSetupResetForm: (state, action) => {
      state.authenticatorSetup.loading = false;
      state.authenticatorSetup.error = null;
      state.authenticatorSetup.data = null;
    },
  },
});

export const {
  getUserListingDataFailure,
  getUserListingDataStart,
  getUserListingDataSuccess,
  getUserListingDataResetForm,
  createUserSuccess,
  createUserStart,
  createUserFailure,
  createUserResetForm,
  assignDeviceStart,
  assignDeviceSuccess,
  assignDeviceFailure,
  assignDeviceResetForm,
  removeDeviceStart,
  removeDeviceFailure,
  removeDeviceSuccess,
  removeDeviceResetForm,

  storeTimezoneStart,
  storeTimezoneSuccess,
  storeTimezoneFailure,
  storeTimezoneResetForm,

  getTimezonesStart,
  getTimezonesSuccess,
  getTimezonesFailure,
  getTimezonesResetForm,

  authenticatorSetupStart,
  authenticatorSetupSuccess,
  authenticatorSetupFailure,
  authenticatorSetupResetForm
  
  
} = authSlice.actions;

export default authSlice.reducer;
